import PAYMENT_FREQUENCY_AND_DIVISOR_MAP from '../definitions/PaymentFrequencyAndDivisorMap';


function getPaymentFrequencyAndDivisor(paymentFrequency) {
    if (!Object.keys(PAYMENT_FREQUENCY_AND_DIVISOR_MAP).includes(paymentFrequency)) {
        throw new RangeError(`Unknown paymentFrequency "${paymentFrequency}"`);
    }

    return PAYMENT_FREQUENCY_AND_DIVISOR_MAP[paymentFrequency];
}

export default getPaymentFrequencyAndDivisor;
